(function () {
  function getSelectedVariantSource(form) {
    var variantSelect = form.querySelector('select[name="id"]');
    var variantRadios = Array.prototype.slice.call(form.querySelectorAll('input[type="radio"][data-variant-picker-radio]'));
    var variantHiddenInput = form.querySelector('input[type="hidden"][name="id"]');

    if (variantSelect) {
      return variantSelect.options[variantSelect.selectedIndex];
    }

    if (variantRadios.length) {
      return variantRadios.find(function (input) {
        return input.checked;
      }) || variantRadios[0];
    }

    return variantHiddenInput;
  }

  function getFocusableElements(container) {
    if (!container) return [];

    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, object, embed, [contenteditable], [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      if (element.hidden) return false;
      if (element.getAttribute('aria-hidden') === 'true') return false;

      return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
    });
  }

  function enableFocusTrap(container, initialFocus) {
    if (!container) return function () {};

    function handleKeydown(event) {
      if (event.key !== 'Tab') return;

      var focusableElements = getFocusableElements(container);
      if (!focusableElements.length) {
        event.preventDefault();
        container.focus();
        return;
      }

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    document.addEventListener('keydown', handleKeydown);

    window.requestAnimationFrame(function () {
      var focusTarget = initialFocus || getFocusableElements(container)[0] || container;
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus();
      }
    });

    return function releaseFocusTrap() {
      document.removeEventListener('keydown', handleKeydown);
    };
  }

  function getDiscountPercentage(priceAmount, comparePriceAmount) {
    var price = Number(priceAmount || 0);
    var comparePrice = Number(comparePriceAmount || 0);

    if (!comparePrice || comparePrice <= price) return 0;

    return Math.round(((comparePrice - price) * 100) / comparePrice);
  }

  function syncPriceDisplay(priceWrapper, currentPriceText, comparePriceText, discountPercentage) {
    if (!priceWrapper) return;

    var priceNode = priceWrapper.querySelector('.price') || priceWrapper;
    var currentPrice = priceNode.querySelector('.price__current');
    var comparePrice = priceNode.querySelector('.price__compare');
    var discountBadge = priceNode.querySelector('.price__badge');

    if (currentPrice && currentPriceText) {
      currentPrice.textContent = currentPriceText;
    }

    if (comparePriceText) {
      if (!comparePrice) {
        comparePrice = document.createElement('span');
        comparePrice.className = 'price__compare';
        priceNode.appendChild(comparePrice);
      }

      comparePrice.textContent = comparePriceText;
      priceNode.classList.add('price--sale');
    } else {
      if (comparePrice) {
        comparePrice.remove();
      }

      priceNode.classList.remove('price--sale');
    }

    if (discountPercentage > 0) {
      if (!discountBadge) {
        discountBadge = document.createElement('span');
        discountBadge.className = 'price__badge';
        priceNode.appendChild(discountBadge);
      }

      discountBadge.textContent = discountPercentage + '%';
    } else if (discountBadge) {
      discountBadge.remove();
    }
  }

  function syncSpecialOffer(container, savingsText, discountPercentage) {
    if (!container) return;

    var specialOfferItem = container.querySelector('[data-special-offer-item]');
    var specialOfferMessage = container.querySelector('[data-special-offer-message]');
    var specialOfferInput = container.querySelector('[data-special-offer-input]');
    var offerCount = container.querySelector('[data-offer-count]');
    if (!specialOfferItem || !offerCount) return;

    var baseCount = Number(offerCount.dataset.baseCount || 0);
    var hasSpecialOffer = Boolean(savingsText) && discountPercentage > 0;
    var specialOfferValue = 'Special Price';

    if (hasSpecialOffer) {
      specialOfferValue += ' - Save ' + savingsText;

      if (discountPercentage > 0) {
        specialOfferValue += ' (' + discountPercentage + '% OFF)';
      }
    }

    specialOfferItem.hidden = !hasSpecialOffer;
    offerCount.textContent = String(baseCount + (hasSpecialOffer ? 1 : 0)) + ' offers';

    if (specialOfferMessage && hasSpecialOffer) {
      specialOfferMessage.textContent = 'Save ' + savingsText + ' (' + discountPercentage + '% OFF) on this selected size compared to MRP.';
    }

    if (specialOfferInput) {
      specialOfferInput.disabled = !hasSpecialOffer;
      specialOfferInput.value = specialOfferValue;

      if (!hasSpecialOffer && specialOfferInput.checked) {
        specialOfferInput.checked = false;
      }
    }
  }

  function initHeader(root) {
    root.querySelectorAll('[data-mobile-nav]').forEach(function (container) {
      if (container.dataset.initialized === 'true') return;

      var toggle = container.querySelector('[data-nav-toggle]');
      var drawer = container.querySelector('[data-nav-drawer]');
      var searchTrigger = container.querySelector('[data-mobile-search-trigger]');
      var searchDialog = container.querySelector('[data-mobile-search]');
      var searchForm = container.querySelector('[data-mobile-search-form]');
      var searchInput = container.querySelector('[data-mobile-search-input]');
      var searchResults = container.querySelector('[data-mobile-search-results]');
      var releaseSearchFocusTrap = function () {};
      var searchRequestId = 0;
      var searchTimer;
      var searchLastTrigger;

      container.dataset.initialized = 'true';

      function closeNavigation() {
        if (!toggle || !drawer) return;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        drawer.hidden = true;
      }

      function closeSearch() {
        if (!searchDialog || searchDialog.hidden) return;
        searchDialog.hidden = true;
        if (searchTrigger) searchTrigger.setAttribute('aria-expanded', 'false');
        releaseSearchFocusTrap();
        releaseSearchFocusTrap = function () {};
        if (searchLastTrigger) searchLastTrigger.focus();
      }

      function escapeSearchHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (character) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
        });
      }

      function renderSearchResults(data, query) {
        if (!searchResults) return;
        var resources = data && data.resources && data.resources.results ? data.resources.results : {};
        var products = Array.isArray(resources.products) ? resources.products.slice(0, 5) : [];
        var queries = Array.isArray(resources.queries) ? resources.queries.slice(0, 2) : [];
        var results = [];

        queries.forEach(function (item) {
          results.push('<a class="mobile-search__result" href="' + escapeSearchHtml(item.url || '') + '"><span>' + escapeSearchHtml(item.text || item.styled_text || query) + '</span><small>Suggestion</small></a>');
        });
        products.forEach(function (item) {
          results.push('<a class="mobile-search__result" href="' + escapeSearchHtml(item.url || '') + '"><span>' + escapeSearchHtml(item.title) + '</span><small>' + escapeSearchHtml(item.price || '') + '</small></a>');
        });

        if (!results.length) {
          results.push('<a class="mobile-search__result" href="' + escapeSearchHtml((searchForm ? searchForm.action : '/search') + '?q=' + encodeURIComponent(query)) + '"><span>Search for “' + escapeSearchHtml(query) + '”</span><small>View all</small></a>');
        }

        searchResults.innerHTML = results.join('');
        searchResults.hidden = false;
      }

      function requestSearchResults() {
        if (!searchInput || !searchForm || !searchResults) return;
        var query = searchInput.value.trim();
        window.clearTimeout(searchTimer);

        if (query.length < 2) {
          searchResults.hidden = true;
          searchResults.innerHTML = '';
          return;
        }

        searchTimer = window.setTimeout(function () {
          var requestId = ++searchRequestId;
          var endpoint = searchForm.dataset.predictiveSearchUrl || '/search/suggest';
          if (!/\.json(?:\?|$)/.test(endpoint)) endpoint += '.json';
          var separator = endpoint.indexOf('?') === -1 ? '?' : '&';
          var url = endpoint + separator + 'q=' + encodeURIComponent(query) + '&resources[type]=product,collection,query&resources[limit]=5';

          fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (response) {
              if (!response.ok) throw new Error('Search unavailable');
              return response.json();
            })
            .then(function (data) {
              if (requestId === searchRequestId) renderSearchResults(data, query);
            })
            .catch(function () {
              if (requestId === searchRequestId) renderSearchResults({}, query);
            });
        }, 180);
      }

      if (toggle && drawer) toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        toggle.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
        drawer.hidden = expanded;
      });

      if (drawer) drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          closeNavigation();
        });
      });

      if (searchTrigger && searchDialog) {
        searchTrigger.addEventListener('click', function () {
          closeNavigation();
          searchLastTrigger = searchTrigger;
          searchDialog.hidden = false;
          searchTrigger.setAttribute('aria-expanded', 'true');
          releaseSearchFocusTrap = enableFocusTrap(searchDialog, searchInput);
        });

        searchDialog.querySelectorAll('[data-mobile-search-close]').forEach(function (closeButton) {
          closeButton.addEventListener('click', closeSearch);
        });
        if (searchInput) searchInput.addEventListener('input', requestSearchResults);
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeNavigation();
          closeSearch();
        }
      });
    });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
      if (slider.dataset.initialized === 'true') return;

      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-slide]'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-slide-dot]'));
      var prev = slider.querySelector('[data-slide-prev]');
      var next = slider.querySelector('[data-slide-next]');
      var autoplayDelay = Number(slider.dataset.autoplayDelay || 5000);
      var activeIndex = 0;
      var intervalId;

      if (!slides.length) return;
      slider.dataset.initialized = 'true';

      function setActiveSlide(index) {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });
      }

      function startAutoplay() {
        if (slides.length < 2) return;
        window.clearInterval(intervalId);
        intervalId = window.setInterval(function () {
          setActiveSlide(activeIndex + 1);
        }, autoplayDelay);
      }

      setActiveSlide(0);
      startAutoplay();

      if (prev) {
        prev.addEventListener('click', function () {
          setActiveSlide(activeIndex - 1);
          startAutoplay();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          setActiveSlide(activeIndex + 1);
          startAutoplay();
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          setActiveSlide(index);
          startAutoplay();
        });
      });

      slider.addEventListener('mouseenter', function () {
        window.clearInterval(intervalId);
      });

      slider.addEventListener('mouseleave', startAutoplay);
    });
  }

  function initVariantForms(root) {
    root.querySelectorAll('[data-variant-root]').forEach(function (container) {
      if (container.dataset.initialized === 'true') return;

      var form = container.querySelector('.js-variant-form');
      if (!form) return;

      var variantSelect = form.querySelector('select[name="id"]');
      var variantRadios = Array.prototype.slice.call(form.querySelectorAll('input[type="radio"][data-variant-picker-radio]'));
      var variantHiddenInput = form.querySelector('input[type="hidden"][name="id"]');
      if (!variantSelect && !variantRadios.length && !variantHiddenInput) return;

      var priceDisplays = Array.prototype.slice.call(container.querySelectorAll('[data-variant-price]'));
      var submitButton = form.querySelector('[data-variant-submit]');
      var submitButtons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'));
      var paymentButton = form.querySelector('.shopify-payment-button');
      var imageWrap = container.querySelector('[data-variant-image]');
      var image = imageWrap ? imageWrap.querySelector('img') : null;
      var thumbs = Array.prototype.slice.call(container.querySelectorAll('[data-gallery-thumb]'));
      var prevButton = container.querySelector('[data-gallery-prev]');
      var nextButton = container.querySelector('[data-gallery-next]');
      var galleryImageRequest = 0;

      container.dataset.initialized = 'true';

      function getActiveVariantSource() {
        return getSelectedVariantSource(form);
      }

      function applyImageState(source) {
        if (!source) return;

        if (image && source.dataset.imageSrc) {
          var requestId = ++galleryImageRequest;
          var thumbImage = source.querySelector ? source.querySelector('img') : null;
          var previewSource = thumbImage ? (thumbImage.currentSrc || thumbImage.src) : '';

          // Gallery arrows should feel instant. The thumbnail image is already
          // loaded, so show it immediately while the larger gallery source is
          // fetched and decoded in the background.
          if (previewSource) {
            image.removeAttribute('srcset');
            image.src = previewSource;
          }

          var fullSizeImage = new Image();
          fullSizeImage.onload = function () {
            if (requestId !== galleryImageRequest) return;

            if (source.dataset.imageSrcset) {
              image.srcset = source.dataset.imageSrcset;
            } else {
              image.removeAttribute('srcset');
            }

            image.src = source.dataset.imageSrc;
          };

          if (source.dataset.imageSrcset) {
            fullSizeImage.srcset = source.dataset.imageSrcset;
            fullSizeImage.sizes = image.sizes || 'min(100vw, 44rem)';
          }
          fullSizeImage.src = source.dataset.imageSrc;

          if (source.dataset.imageAlt) {
            image.alt = source.dataset.imageAlt;
          }
        }

        if (imageWrap) {
          imageWrap.dataset.activeMediaId = source.dataset.mediaId || '';
        }

        setActiveThumb(source.dataset.mediaId || '');
      }

      function updateVariantState() {
        var option = getActiveVariantSource();
        if (!option) return;

        var available = option.dataset.available === 'true';
        var discountPercentage = Number(option.dataset.discountPercentage || 0);

        // Subscription apps (including Essential Subscriptions) observe one stable
        // `name="id"` input. Keep it in sync with our visual radio tabs and emit
        // a native change event so their One-time / subscription prices refresh.
        if (variantHiddenInput && variantHiddenInput.value !== option.value) {
          variantHiddenInput.value = option.value;
          variantHiddenInput.setAttribute('value', option.value);
          variantHiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (priceDisplays.length && option.dataset.price) {
          priceDisplays.forEach(function (priceDisplay) {
            syncPriceDisplay(priceDisplay, option.dataset.price, option.dataset.comparePrice, discountPercentage);
          });
        }

        submitButtons.forEach(function (button) {
          button.disabled = !available;

          if (button.hasAttribute('data-variant-submit') || button.dataset.action === 'checkout') {
            button.textContent = available
              ? button.dataset.availableLabel || 'Add to cart'
              : button.dataset.unavailableLabel || 'Sold out';
          }
        });

        if (paymentButton) {
          paymentButton.hidden = !available;
        }

        syncSpecialOffer(container, option.dataset.savings, discountPercentage);
        applyImageState(option);

        // Let subscription / purchase-option widgets refresh their own "Just Once"
        // and plan prices when the shopper selects a different Shopify variant.
        document.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: {
            variant: {
              id: option.value,
              title: option.dataset.variantTitle || '',
              price: Number(option.dataset.priceAmount || 0) * 100,
              compare_at_price: option.dataset.comparePriceAmount
                ? Number(option.dataset.comparePriceAmount) * 100
                : null,
              available: available
            },
            form: form,
            source: option
          }
        }));
      }

      function setActiveThumb(mediaId) {
        thumbs.forEach(function (thumb) {
          var isActive = thumb.dataset.mediaId === String(mediaId);
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', String(isActive));
        });
      }

      function getActiveThumbIndex() {
        var activeMediaId = imageWrap ? imageWrap.dataset.activeMediaId : '';
        var activeIndex = thumbs.findIndex(function (thumb) {
          return thumb.dataset.mediaId === String(activeMediaId);
        });

        if (activeIndex >= 0) return activeIndex;

        return thumbs.findIndex(function (thumb) {
          return thumb.classList.contains('is-active');
        });
      }

      function stepGallery(direction) {
        if (!thumbs.length) return;

        var activeIndex = getActiveThumbIndex();
        var nextIndex = activeIndex >= 0 ? activeIndex + direction : 0;
        nextIndex = (nextIndex + thumbs.length) % thumbs.length;

        applyImageState(thumbs[nextIndex]);
        thumbs[nextIndex].scrollIntoView({
          block: 'nearest',
          inline: 'nearest'
        });
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', updateVariantState);
      }

      variantRadios.forEach(function (input) {
        input.addEventListener('change', updateVariantState);
      });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          applyImageState(thumb);
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          stepGallery(-1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          stepGallery(1);
        });
      }

      updateVariantState();
    });
  }

  function initTabbedCollections(root) {
    root.querySelectorAll('[data-tabbed-collections]').forEach(function (container) {
      if (container.dataset.initialized === 'true') return;

      var tabs = Array.prototype.slice.call(container.querySelectorAll('[data-tab-trigger]'));
      var panels = Array.prototype.slice.call(container.querySelectorAll('[data-tab-panel]'));
      if (!tabs.length || !panels.length) return;

      container.dataset.initialized = 'true';
      var lastPrimaryTabId = null;

      function setSecondaryTabs(hidden) {
        tabs.forEach(function (tab) {
          if (tab.dataset.tabRole !== 'secondary') return;

          tab.hidden = hidden;
          if (hidden) {
            tab.classList.remove('is-active');
            tab.setAttribute('aria-selected', 'false');
          }
        });
      }

      function activateTab(tabId) {
        var allTab = tabs.find(function (tab) {
          return tab.dataset.tabRole === 'all';
        });

        if (tabId === 'all') {
          if (container.classList.contains('is-showing-all')) {
            var fallbackTab = tabs.find(function (tab) {
              return tab.dataset.tabRole === 'primary';
            }) || tabs[0];
            activateTab(lastPrimaryTabId || fallbackTab.dataset.tabId);
            return;
          }

          setSecondaryTabs(false);
          container.classList.add('is-showing-all');

          tabs.forEach(function (tab) {
            if (tab.dataset.tabRole === 'primary') {
              tab.classList.remove('is-active');
              tab.setAttribute('aria-selected', 'false');
            }
          });

          if (allTab) {
            allTab.classList.add('is-active');
            allTab.setAttribute('aria-selected', 'true');
          }

          return;
        }

        lastPrimaryTabId = tabId;
        setSecondaryTabs(true);
        container.classList.remove('is-showing-all');

        tabs.forEach(function (tab) {
          var isActive = tab.dataset.tabId === tabId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach(function (panel) {
          var isActive = panel.dataset.tabPanelId === tabId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        if (allTab) {
          allTab.classList.remove('is-active');
          allTab.setAttribute('aria-selected', 'false');
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (tab.dataset.tabRole === 'all') {
            activateTab('all');
            return;
          }

          activateTab(tab.dataset.tabId);
        });
      });

      container.addEventListener('shopify:block:select', function (event) {
        var selectedPanel = event.target.closest('[data-tab-panel]');
        if (!selectedPanel) return;

        activateTab(selectedPanel.dataset.tabPanelId);
        selectedPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });

      var defaultPrimaryTab = tabs.find(function (tab) {
        return tab.dataset.tabRole === 'primary';
      }) || tabs[0];
      activateTab(defaultPrimaryTab.dataset.tabId);
    });
  }

  function initCollectionSliders(root) {
    root.querySelectorAll('[data-collection-slider]').forEach(function (slider) {
      if (slider.dataset.initialized === 'true') return;

      if (window.matchMedia('(max-width: 749px)').matches) {
        slider.dataset.initialized = 'true';
        return;
      }

      var track = slider.querySelector('[data-collection-track]');
      if (!track) return;

      var prev = slider.querySelector('[data-collection-prev]');
      var next = slider.querySelector('[data-collection-next]');
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.tabbed-collections__slide'));
      slider.dataset.initialized = 'true';

      function getScrollAmount() {
        var firstSlide = slides[0];
        var gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');

        if (firstSlide) {
          return firstSlide.getBoundingClientRect().width + gap;
        }

        return Math.max(track.clientWidth * 0.82, 280);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }
    });
  }

  function initProductSupportTabs(root) {
    root.querySelectorAll('[data-product-support-tabs]').forEach(function (container) {
      if (container.dataset.initialized === 'true') return;

      var tabs = Array.prototype.slice.call(container.querySelectorAll('[data-product-support-tab]'));
      var panels = Array.prototype.slice.call(container.querySelectorAll('[data-product-support-panel]'));
      if (!tabs.length || !panels.length) return;

      container.dataset.initialized = 'true';

      function activateTab(targetId) {
        tabs.forEach(function (tab) {
          var isActive = tab.dataset.tabTarget === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach(function (panel) {
          var isActive = panel.dataset.tabPanel === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(tab.dataset.tabTarget);
        });

        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

          event.preventDefault();
          var nextIndex = event.key === 'ArrowRight' ? index + 1 : index - 1;

          if (nextIndex < 0) nextIndex = tabs.length - 1;
          if (nextIndex >= tabs.length) nextIndex = 0;

          tabs[nextIndex].focus();
          activateTab(tabs[nextIndex].dataset.tabTarget);
        });
      });

      activateTab(tabs[0].dataset.tabTarget);
    });
  }

  function initBestSellerSliders(root) {
    root.querySelectorAll('[data-best-seller-slider]').forEach(function (slider) {
      if (slider.dataset.initialized === 'true') return;

      var track = slider.querySelector('[data-best-seller-track]');
      if (!track) return;

      var prev = slider.querySelector('[data-best-seller-prev]');
      var next = slider.querySelector('[data-best-seller-next]');
      var slides = Array.prototype.slice.call(track.children);
      var originalSlides = slides.slice();
      var autoplayDelay = Number(slider.dataset.bestSellerAutoplayDelay || 4000);
      var autoplayId;
      var resizeObserver = null;
      var loopSlidesAppended = false;
      slider.dataset.initialized = 'true';

      function getScrollAmount() {
        var firstSlide = slides[0];
        var gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');

        if (firstSlide) {
          return firstSlide.getBoundingClientRect().width + gap;
        }

        return Math.max(track.clientWidth * 0.82, 240);
      }

      function getMaxScrollLeft() {
        return Math.max(track.scrollWidth - track.clientWidth - 4, 0);
      }

      function watchSlideImages(slidesToWatch) {
        slidesToWatch.forEach(function (slide) {
          slide.querySelectorAll('img').forEach(function (image) {
            if (image.complete) return;
            image.addEventListener('load', refreshSlider, { once: true });
            image.addEventListener('error', refreshSlider, { once: true });
          });
        });
      }

      function appendLoopClones() {
        if (loopSlidesAppended || originalSlides.length < 2) return;

        originalSlides.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.dataset.bestSellerClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);

          if (resizeObserver) {
            resizeObserver.observe(clone);
          }

          watchSlideImages([clone]);
        });

        slides = Array.prototype.slice.call(track.children);
        loopSlidesAppended = true;
      }

      function syncLoopCloneContent() {
        if (!loopSlidesAppended) return;

        originalSlides.forEach(function (slide, index) {
          var clone = slides[originalSlides.length + index];
          if (clone && clone.innerHTML !== slide.innerHTML) {
            clone.innerHTML = slide.innerHTML;
          }
        });
      }

      function moveTrack(direction) {
        var maxScrollLeft = getMaxScrollLeft();
        var nextLeft = track.scrollLeft + (getScrollAmount() * direction);

        if (direction > 0 && track.scrollLeft >= maxScrollLeft - 4) {
          nextLeft = 0;
        } else if (direction < 0 && track.scrollLeft <= 4) {
          nextLeft = loopSlidesAppended ? Math.max(0, maxScrollLeft - getScrollAmount()) : maxScrollLeft;
        }

        track.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' });
      }

      function updateState() {
        var maxScrollLeft = getMaxScrollLeft();
        slider.classList.toggle('is-static', maxScrollLeft <= 0);

        if (prev) {
          prev.disabled = loopSlidesAppended ? false : track.scrollLeft <= 4;
        }

        if (next) {
          next.disabled = loopSlidesAppended ? false : track.scrollLeft >= maxScrollLeft;
        }
      }

      function refreshSlider() {
        if (!loopSlidesAppended && originalSlides.length > 1 && getMaxScrollLeft() <= 0) {
          appendLoopClones();
        }

        if (typeof syncLoopCloneContent === 'function') {
          syncLoopCloneContent();
        }
        updateState();
      }

      function stopAutoplay() {
        window.clearInterval(autoplayId);
        autoplayId = null;
      }

      function shouldAutoplay() {
        return originalSlides.length > 1 && !slider.classList.contains('is-static');
      }

      function startAutoplay() {
        stopAutoplay();
        if (!shouldAutoplay()) return;

        autoplayId = window.setInterval(function () {
          moveTrack(1);
        }, autoplayDelay);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          moveTrack(-1);
          startAutoplay();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          moveTrack(1);
          startAutoplay();
        });
      }

      track.addEventListener('scroll', updateState, { passive: true });
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      slider.addEventListener('focusin', stopAutoplay);
      slider.addEventListener('focusout', startAutoplay);
      watchSlideImages(originalSlides);

      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(refreshSlider);
        resizeObserver.observe(track);
        slides.forEach(function (slide) {
          resizeObserver.observe(slide);
        });
      } else {
        window.addEventListener('resize', refreshSlider);
      }

      if (window.MutationObserver) {
      if (typeof syncLoopCloneContent === 'function') {
        var cloneSyncObserver = new MutationObserver(syncLoopCloneContent);
        originalSlides.forEach(function (slide) {
          cloneSyncObserver.observe(slide, {
            attributes: true,
            attributeFilter: ['src', 'srcset'],
            childList: true,
            subtree: true
          });
        });
      }
      }

      document.addEventListener('shopify:block:select', refreshSlider);
      refreshSlider();
      startAutoplay();
    });
  }

  function initConcernSliders(root) {
    root.querySelectorAll('[data-concern-slider]').forEach(function (slider) {
      if (slider.dataset.initialized === 'true') return;

      var track = slider.querySelector('[data-concern-track]');
      if (!track) return;

      var prev = slider.querySelector('[data-concern-prev]');
      var next = slider.querySelector('[data-concern-next]');
      var slides = Array.prototype.slice.call(track.children);
      var originalSlides = slides.slice();
      var autoplayDelay = Number(slider.dataset.concernAutoplayDelay || 3200);
      var autoplayId;
      var resizeObserver = null;
      var loopSlidesAppended = false;
      slider.dataset.initialized = 'true';

      function getScrollAmount() {
        var firstSlide = slides[0];
        var gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');

        if (firstSlide) {
          return firstSlide.getBoundingClientRect().width + gap;
        }

        return Math.max(track.clientWidth * 0.72, 160);
      }

      function getMaxScrollLeft() {
        return Math.max(track.scrollWidth - track.clientWidth - 4, 0);
      }

      function watchSlideImages(slidesToWatch) {
        slidesToWatch.forEach(function (slide) {
          slide.querySelectorAll('img').forEach(function (image) {
            if (image.complete) return;
            image.addEventListener('load', refreshSlider, { once: true });
            image.addEventListener('error', refreshSlider, { once: true });
          });
        });
      }

      function appendLoopClones() {
        if (loopSlidesAppended || originalSlides.length < 2) return;

        originalSlides.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.dataset.concernClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);

          if (resizeObserver) {
            resizeObserver.observe(clone);
          }

          watchSlideImages([clone]);
        });

        slides = Array.prototype.slice.call(track.children);
        loopSlidesAppended = true;
      }

      // Keep the continuous certification rail exactly as designed, but copy
      // a Theme Editor image update to its matching loop clone as well.
      function syncLoopCloneContent() {
        if (!loopSlidesAppended) return;

        originalSlides.forEach(function (slide, index) {
          var clone = slides[originalSlides.length + index];
          if (clone && clone.innerHTML !== slide.innerHTML) {
            clone.innerHTML = slide.innerHTML;
          }
        });
      }

      function moveTrack(direction) {
        var maxScrollLeft = getMaxScrollLeft();
        var nextLeft = track.scrollLeft + (getScrollAmount() * direction);

        if (direction > 0 && track.scrollLeft >= maxScrollLeft - 4) {
          nextLeft = 0;
        } else if (direction < 0 && track.scrollLeft <= 4) {
          nextLeft = loopSlidesAppended ? Math.max(0, maxScrollLeft - getScrollAmount()) : maxScrollLeft;
        }

        track.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' });
      }

      function updateState() {
        var maxScrollLeft = getMaxScrollLeft();
        slider.classList.toggle('is-static', maxScrollLeft <= 0);

        if (prev) {
          prev.disabled = loopSlidesAppended ? false : track.scrollLeft <= 4;
        }

        if (next) {
          next.disabled = loopSlidesAppended ? false : track.scrollLeft >= maxScrollLeft;
        }
      }

      function refreshSlider() {
        // Certification badges must always have a second pass of slides: this
        // keeps their intended repeating/autoplay rail active even when the
        // first five badges happen to fit in a wide viewport.
        var requiresLoopClones = slider.classList.contains('trust-availability__slider--certs');
        if (!loopSlidesAppended && originalSlides.length > 1 && (requiresLoopClones || getMaxScrollLeft() <= 0)) {
          appendLoopClones();
        }

        syncLoopCloneContent();
        updateState();
      }

      function stopAutoplay() {
        window.clearInterval(autoplayId);
        autoplayId = null;
      }

      function shouldAutoplay() {
        return originalSlides.length > 1 && !slider.classList.contains('is-static');
      }

      function startAutoplay() {
        stopAutoplay();
        if (!shouldAutoplay()) return;

        autoplayId = window.setInterval(function () {
          moveTrack(1);
        }, autoplayDelay);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          moveTrack(-1);
          startAutoplay();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          moveTrack(1);
          startAutoplay();
        });
      }

      track.addEventListener('scroll', updateState, { passive: true });
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      slider.addEventListener('focusin', stopAutoplay);
      slider.addEventListener('focusout', startAutoplay);
      watchSlideImages(originalSlides);

      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(refreshSlider);
        resizeObserver.observe(track);
        slides.forEach(function (slide) {
          resizeObserver.observe(slide);
        });
      } else {
        window.addEventListener('resize', refreshSlider);
      }

      document.addEventListener('shopify:block:select', refreshSlider);
      refreshSlider();
      startAutoplay();
    });
  }

  function initLogoRails(root) {
    root.querySelectorAll('[data-logo-rail]').forEach(function (slider) {
      if (slider.dataset.initialized === 'true') return;

      var track = slider.querySelector('[data-logo-track]');
      if (!track) return;

      var prev = slider.querySelector('[data-logo-prev]');
      var next = slider.querySelector('[data-logo-next]');
      var slides = Array.prototype.slice.call(track.children);
      var originalSlides = slides.slice();
      var autoplayMode = slider.dataset.logoAutoplay || 'off';
      var autoplayDelay = Number(slider.dataset.logoAutoplayDelay || 3200);
      var autoplayId;
      var resizeObserver = null;
      var loopSlidesAppended = false;
      slider.dataset.initialized = 'true';

      function getScrollAmount() {
        var firstSlide = slides[0];
        var gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');

        if (firstSlide) {
          return firstSlide.getBoundingClientRect().width + gap;
        }

        return Math.max(track.clientWidth * 0.72, 180);
      }

      function getMaxScrollLeft() {
        return Math.max(track.scrollWidth - track.clientWidth - 4, 0);
      }

      function watchSlideImages(slidesToWatch) {
        slidesToWatch.forEach(function (slide) {
          slide.querySelectorAll('img').forEach(function (image) {
            if (image.complete) return;
            image.addEventListener('load', refreshRail, { once: true });
            image.addEventListener('error', refreshRail, { once: true });
          });
        });
      }

      function appendLoopClones() {
        if (loopSlidesAppended || originalSlides.length < 2) return;

        // When every item fits inside the row, duplicate the original set once
        // so the carousel still has a scrollable range without changing card design.
        originalSlides.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.dataset.logoClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);

          if (resizeObserver) {
            resizeObserver.observe(clone);
          }

          watchSlideImages([clone]);
        });

        slides = Array.prototype.slice.call(track.children);
        loopSlidesAppended = true;
      }

      function shouldAutoplay() {
        if (autoplayMode === 'off') return false;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
        if (getMaxScrollLeft() <= 0) return false;
        if (autoplayMode === 'mobile') return window.matchMedia('(max-width: 768px)').matches;
        return true;
      }

      function moveTrack(direction) {
        var maxScrollLeft = getMaxScrollLeft();
        var nextLeft = track.scrollLeft + (getScrollAmount() * direction);

        if (direction > 0 && track.scrollLeft >= maxScrollLeft - 4) {
          nextLeft = 0;
        } else if (direction < 0 && track.scrollLeft <= 4) {
          nextLeft = loopSlidesAppended ? Math.max(0, maxScrollLeft - getScrollAmount()) : maxScrollLeft;
        }

        track.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' });
      }

      function updateState() {
        var maxScrollLeft = getMaxScrollLeft();
        slider.classList.toggle('is-static', maxScrollLeft <= 0);

        if (prev) {
          prev.disabled = loopSlidesAppended ? false : track.scrollLeft <= 4;
        }

        if (next) {
          next.disabled = loopSlidesAppended ? false : track.scrollLeft >= maxScrollLeft;
        }
      }

      function stopAutoplay() {
        window.clearInterval(autoplayId);
      }

      function startAutoplay() {
        stopAutoplay();

        if (!shouldAutoplay()) return;

        autoplayId = window.setInterval(function () {
          moveTrack(1);
        }, autoplayDelay);
      }

      function refreshRail() {
        if (!loopSlidesAppended && originalSlides.length > 1 && getMaxScrollLeft() <= 0) {
          appendLoopClones();
        }

        updateState();
        startAutoplay();
      }

      if (prev) {
        prev.addEventListener('click', function () {
          moveTrack(-1);
          startAutoplay();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          moveTrack(1);
          startAutoplay();
        });
      }

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      slider.addEventListener('focusin', stopAutoplay);
      slider.addEventListener('focusout', function (event) {
        if (slider.contains(event.relatedTarget)) return;
        startAutoplay();
      });
      slider.addEventListener('touchstart', stopAutoplay, { passive: true });
      slider.addEventListener('touchend', startAutoplay, { passive: true });
      slider.addEventListener('shopify:block:select', function (event) {
        var selectedSlide = event.target.closest('.trust-logo-card');
        if (!selectedSlide || !track.contains(selectedSlide)) return;

        selectedSlide.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: 'smooth'
        });
        refreshRail();
      });

      track.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', function () {
        refreshRail();
      });
      watchSlideImages(originalSlides);

      if (typeof ResizeObserver === 'function') {
        resizeObserver = new ResizeObserver(refreshRail);
        resizeObserver.observe(track);
        originalSlides.forEach(function (slide) {
          resizeObserver.observe(slide);
        });
      }

      window.requestAnimationFrame(refreshRail);
      window.setTimeout(refreshRail, 180);
    });
  }

  function initCartFlowForms(root) {
    root.querySelectorAll('[data-cart-flow-form]').forEach(function (form) {
      if (form.dataset.initialized === 'true') return;

      form.dataset.initialized = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var submitButton = event.submitter || form.querySelector('[type="submit"]');
        if (submitButton && submitButton.disabled) return;

        var status = form.querySelector('[data-cart-flow-status]');
        var originalLabel = submitButton ? submitButton.textContent : '';
        var formData = new FormData(form);
        var rootUrl = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
        var redirectUrl = form.dataset.cartRedirectUrl || rootUrl + 'cart';
        var loadingLabel = submitButton && submitButton.dataset.loadingLabel
          ? submitButton.dataset.loadingLabel
          : (form.dataset.loadingLabel || 'Adding...');

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = loadingLabel;
        }

        if (status) {
          status.hidden = true;
          status.textContent = '';
          status.classList.remove('is-error');
        }

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                throw new Error(data.description || 'Unable to add this product to the cart.');
              }

              if (submitButton && submitButton.dataset.action === 'checkout') {
                window.location.href = rootUrl + 'checkout';
                return null;
              }

              if (window.SarabCartDrawer && typeof window.SarabCartDrawer.refresh === 'function') {
                if (submitButton) {
                  submitButton.disabled = false;
                  submitButton.textContent = originalLabel;
                }
                return window.SarabCartDrawer.refresh(true);
              }

              window.location.href = redirectUrl;
              return null;
            });
          })
          .catch(function (error) {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = originalLabel;
            }

            if (status) {
              status.hidden = false;
              status.textContent = error.message;
              status.classList.add('is-error');
            } else {
              window.alert(error.message);
            }
          });
      });
    });
  }

  function initCartDrawer(root) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var content = drawer.querySelector('[data-cart-drawer-content]');
    var panel = drawer.querySelector('.cart-drawer__panel');
    var rootUrl = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    var currencyCode = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'INR';
    var closeTimer = null;
    var releaseDrawerFocusTrap = function () {};
    var previousActiveElement = null;

    if (drawer.dataset.bound !== 'true') {
      drawer.dataset.bound = 'true';

      drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (node) {
        node.addEventListener('click', closeDrawer);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !drawer.hidden) {
          closeDrawer();
        }
      });
    }

    root.querySelectorAll('[data-cart-drawer-trigger]').forEach(function (trigger) {
      if (trigger.dataset.cartDrawerBound === 'true') return;

      trigger.dataset.cartDrawerBound = 'true';
      trigger.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        previousActiveElement = trigger;
        openDrawer();
      });
    });

    window.SarabCartDrawer = {
      open: openDrawer,
      close: closeDrawer,
      refresh: function (openAfterRefresh) {
        return fetchAndRender().then(function () {
          if (openAfterRefresh) {
            openDrawer(false);
          }
        });
      }
    };

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function setLoadingState() {
      content.innerHTML = [
        '<div class="cart-drawer__loading">',
        '<span class="cart-drawer__spinner" aria-hidden="true"></span>',
        '<p>Loading your cart...</p>',
        '</div>'
      ].join('');
    }

    function openDrawer(fetchFresh) {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      releaseDrawerFocusTrap();

      if (fetchFresh !== false) {
        setLoadingState();
      }

      if (document.activeElement && typeof document.activeElement.focus === 'function') {
        previousActiveElement = document.activeElement;
      }

      drawer.hidden = false;
      document.body.classList.add('cart-drawer-open');
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-active');
        releaseDrawerFocusTrap = enableFocusTrap(panel, panel);
      });

      if (fetchFresh !== false) {
        fetchAndRender();
      }
    }

    function closeDrawer() {
      releaseDrawerFocusTrap();
      releaseDrawerFocusTrap = function () {};
      drawer.classList.remove('is-active');
      document.body.classList.remove('cart-drawer-open');

      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus();
      }

      closeTimer = window.setTimeout(function () {
        if (!drawer.classList.contains('is-active')) {
          drawer.hidden = true;
        }
      }, 280);
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (node) {
        node.textContent = String(count);
      });
    }

    function fetchCart() {
      return fetch(rootUrl + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load cart.');
        }

        return response.json();
      });
    }

    function fetchAndRender() {
      return fetchCart()
        .then(function (cart) {
          renderCart(cart);
          updateCartCount(cart.item_count);
        })
        .catch(function (error) {
          content.innerHTML = '<div class="cart-drawer__empty"><p class="muted">' + escapeHtml(error.message) + '</p></div>';
        });
    }

    function renderCart(cart) {
      if (!cart || !cart.items || !cart.items.length) {
        content.innerHTML = [
          '<div class="cart-drawer__header">',
          '<h2 id="CartDrawerTitle">Your Cart</h2>',
          '<button class="cart-drawer__close" type="button" aria-label="Close cart" data-cart-drawer-close>&times;</button>',
          '</div>',
          '<div class="cart-drawer__empty">',
          '<p class="muted">Your cart is currently empty.</p>',
          '<a class="button" href="' + rootUrl + 'collections/all">Continue shopping</a>',
          '</div>'
        ].join('');
        bindDrawerContent();
        return;
      }

      function renderItemProperties(item) {
        if (!item || !item.properties) return '';

        return Object.keys(item.properties).filter(function (key) {
          var value = item.properties[key];
          return key && key.charAt(0) !== '_' && value !== null && value !== '';
        }).map(function (key) {
          return '<span class="cart-drawer__item-property"><strong>' + escapeHtml(key) + ':</strong> ' + escapeHtml(item.properties[key]) + '</span>';
        }).join('');
      }

      var itemsMarkup = cart.items.map(function (item) {
        var variantText = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';
        var propertyText = renderItemProperties(item);
        var comparePrice = item.original_line_price > item.final_line_price
          ? '<span class="price__compare">' + escapeHtml(formatMoney(item.original_line_price)) + '</span>'
          : '';
        var image = item.image
          ? '<img class="cart-drawer__item-image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">'
          : '<div class="cart-drawer__item-image cart-drawer__item-image--placeholder"></div>';

        return [
          '<article class="cart-drawer__item" data-cart-line-item data-line-key="', escapeHtml(item.key), '">',
          '<div class="cart-drawer__item-media">', image, '</div>',
          '<div class="cart-drawer__item-copy">',
          '<div class="cart-drawer__item-top">',
          '<div>',
          '<h3><a href="', escapeHtml(item.url), '">', escapeHtml(item.product_title), '</a></h3>',
          variantText,
          propertyText,
          '</div>',
          '<div class="cart-drawer__item-price">',
          comparePrice,
          '<strong>', escapeHtml(formatMoney(item.final_line_price)), '</strong>',
          '</div>',
          '</div>',
          '<div class="cart-drawer__item-bottom">',
          '<button class="cart-drawer__remove" type="button" data-cart-remove data-line-key="', escapeHtml(item.key), '" aria-label="Remove ', escapeHtml(item.product_title), '">Remove</button>',
          '<div class="cart-drawer__qty" data-cart-qty>',
          '<button type="button" data-cart-qty-change="-1" data-line-key="', escapeHtml(item.key), '" aria-label="Decrease quantity">-</button>',
          '<input type="number" value="', escapeHtml(item.quantity), '" min="1" aria-label="Quantity for ', escapeHtml(item.product_title), '" data-cart-qty-input data-line-key="', escapeHtml(item.key), '">',
          '<button type="button" data-cart-qty-change="1" data-line-key="', escapeHtml(item.key), '" aria-label="Increase quantity">+</button>',
          '</div>',
          '</div>',
          '</div>',
          '</article>'
        ].join('');
      }).join('');

      content.innerHTML = [
        '<div class="cart-drawer__header">',
        '<h2 id="CartDrawerTitle">Your Cart</h2>',
        '<button class="cart-drawer__close" type="button" aria-label="Close cart" data-cart-drawer-close>&times;</button>',
        '</div>',
        '<div class="cart-drawer__items">', itemsMarkup, '</div>',
        '<div class="cart-drawer__footer">',
        '<div class="cart-drawer__subtotal">',
        '<span>Subtotal</span>',
        '<strong>', escapeHtml(formatMoney(cart.total_price)), '</strong>',
        '</div>',
        '<p class="cart-drawer__note">Shipping, taxes, and final discounts are calculated at checkout.</p>',
        '<div class="cart-drawer__actions">',
        '<a class="button" href="' + rootUrl + 'checkout">Check out</a>',
        '</div>',
        '</div>'
      ].join('');

      bindDrawerContent();
    }

    function bindDrawerContent() {
      releaseDrawerFocusTrap();
      releaseDrawerFocusTrap = enableFocusTrap(
        panel,
        drawer.querySelector('.cart-drawer__close') || panel
      );

      content.querySelectorAll('[data-cart-drawer-close]').forEach(function (node) {
        node.addEventListener('click', closeDrawer);
      });

      content.querySelectorAll('[data-cart-remove]').forEach(function (button) {
        button.addEventListener('click', function () {
          updateLine(button.dataset.lineKey, 0);
        });
      });

      content.querySelectorAll('[data-cart-qty-change]').forEach(function (button) {
        button.addEventListener('click', function () {
          var input = content.querySelector('[data-cart-qty-input][data-line-key="' + button.dataset.lineKey + '"]');
          var nextValue = Math.max(0, (Number(input.value) || 1) + Number(button.dataset.cartQtyChange || 0));
          updateLine(button.dataset.lineKey, nextValue);
        });
      });

      content.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          updateLine(input.dataset.lineKey, Math.max(0, Number(input.value) || 0));
        });
      });
    }

    function updateLine(lineKey, quantity) {
      var line = content.querySelector('[data-cart-line-item][data-line-key="' + lineKey + '"]');
      if (line) {
        line.classList.add('is-updating');
      }

      fetch(rootUrl + 'cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Unable to update the cart.');
            });
          }

          return response.json();
        })
        .then(function (cart) {
          renderCart(cart);
          updateCartCount(cart.item_count);
        })
        .catch(function (error) {
          window.alert(error.message);
          fetchAndRender();
        });
    }
  }

  function initQuickView(root) {
    var modal = document.querySelector('[data-quick-view]');
    if (!modal) return;

    var content = modal.querySelector('[data-quick-view-content]');
    var dialog = modal.querySelector('.quick-view__dialog');
    var closeControls = Array.prototype.slice.call(modal.querySelectorAll('[data-quick-view-close]'));
    var rootUrl = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    var currencyCode = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'INR';
    var cache = window.__quickViewProductCache || (window.__quickViewProductCache = {});
    var releaseQuickViewFocusTrap = function () {};

    if (modal.dataset.bound !== 'true') {
      modal.dataset.bound = 'true';

      closeControls.forEach(function (control) {
        control.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });
    }

    root.querySelectorAll('[data-quick-view-trigger]').forEach(function (trigger) {
      if (trigger.dataset.quickViewBound === 'true') return;

      trigger.dataset.quickViewBound = 'true';
      trigger.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        openModal(trigger);
      });
    });

    window.SarabQuickView = {
      close: closeModal
    };

    function closeModal() {
      releaseQuickViewFocusTrap();
      releaseQuickViewFocusTrap = function () {};
      modal.hidden = true;
      document.body.classList.remove('quick-view-open');
      content.innerHTML = [
        '<div class="quick-view__loading">',
        '<span class="quick-view__spinner" aria-hidden="true"></span>',
        '<p>Loading product details...</p>',
        '</div>'
      ].join('');

      var activeTrigger = window.__quickViewActiveTrigger;
      if (activeTrigger && typeof activeTrigger.focus === 'function') {
        activeTrigger.focus();
      }
    }

    function openModal(trigger) {
      var handle = trigger.dataset.productHandle;
      var fallbackUrl = trigger.getAttribute('href');

      if (!handle || !fallbackUrl) {
        if (fallbackUrl) window.location.href = fallbackUrl;
        return;
      }

      window.__quickViewActiveTrigger = trigger;
      modal.hidden = false;
      document.body.classList.add('quick-view-open');
      content.innerHTML = [
        '<div class="quick-view__loading">',
        '<span class="quick-view__spinner" aria-hidden="true"></span>',
        '<p>Loading product details...</p>',
        '</div>'
      ].join('');
      releaseQuickViewFocusTrap();
      releaseQuickViewFocusTrap = enableFocusTrap(dialog, dialog);

      fetchProduct(handle)
        .then(function (product) {
          renderQuickView(product, fallbackUrl);
        })
        .catch(function () {
          window.location.href = fallbackUrl;
        });
    }

    function fetchProduct(handle) {
      if (cache[handle]) return Promise.resolve(cache[handle]);

      return fetch(rootUrl + 'products/' + handle + '.js', {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to load product details.');
          }

          return response.json();
        })
        .then(function (product) {
          cache[handle] = product;
          return product;
        });
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    }

    function getVariantImage(product, variant) {
      if (variant && variant.featured_image) {
        if (typeof variant.featured_image === 'string') return variant.featured_image;
        if (variant.featured_image.src) return variant.featured_image.src;
        if (variant.featured_image.url) return variant.featured_image.url;
      }

      if (product.featured_image) return product.featured_image;
      if (product.images && product.images.length) return product.images[0];
      return '';
    }

    function truncateWords(value, limit) {
      var words = String(value || '').trim().split(/\s+/).filter(Boolean);
      if (words.length <= limit) return words.join(' ');
      return words.slice(0, limit).join(' ') + '...';
    }

    function stripHtml(value) {
      var fragment = document.createElement('div');
      fragment.innerHTML = value || '';
      return fragment.textContent || fragment.innerText || '';
    }

    function renderQuickView(product, fallbackUrl) {
      var currentVariant = product.variants.find(function (variant) {
        return variant.available;
      }) || product.variants[0];
      var summary = truncateWords(stripHtml(product.description), 32);
      var imageUrl = getVariantImage(product, currentVariant);
      var hasComparePrice = currentVariant && currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price;
      var discountPercentage = hasComparePrice
        ? getDiscountPercentage(currentVariant.price, currentVariant.compare_at_price)
        : 0;
      var variantOptions = product.variants.map(function (variant) {
        return [
          '<option',
          ' value="', escapeHtml(variant.id), '"',
          ' data-available="', escapeHtml(variant.available), '"',
          ' data-price="', escapeHtml(variant.price), '"',
          ' data-compare-price="', escapeHtml(variant.compare_at_price || ''), '"',
          ' data-image="', escapeHtml(getVariantImage(product, variant)), '"',
          variant.id === currentVariant.id ? ' selected' : '',
          variant.available ? '' : ' disabled',
          '>',
          escapeHtml(variant.title), ' - ', escapeHtml(formatMoney(variant.price)),
          '</option>'
        ].join('');
      }).join('');

      content.innerHTML = [
        '<div class="quick-view__layout" data-quick-view-root>',
        '<div class="quick-view__media">',
        imageUrl
          ? '<img class="quick-view__image" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(product.title) + '">'
          : '<div class="quick-view__image quick-view__image--placeholder"></div>',
        '</div>',
        '<div class="quick-view__panel">',
        '<div class="quick-view__meta">',
        product.vendor ? '<span class="quick-view__pill">' + escapeHtml(product.vendor) + '</span>' : '',
        product.type ? '<span class="quick-view__pill">' + escapeHtml(product.type) + '</span>' : '',
        currentVariant && currentVariant.available
          ? '<span class="quick-view__stock is-in">In stock</span>'
          : '<span class="quick-view__stock is-out">Sold out</span>',
        '</div>',
        '<h2 class="quick-view__title" id="QuickViewTitle">' + escapeHtml(product.title) + '</h2>',
        '<div class="quick-view__price price' + (hasComparePrice ? ' price--sale' : '') + '" data-quick-view-price>',
        '<strong class="price__current">' + escapeHtml(formatMoney(currentVariant.price)) + '</strong>',
        hasComparePrice ? '<span class="price__compare">' + escapeHtml(formatMoney(currentVariant.compare_at_price)) + '</span>' : '',
        hasComparePrice ? '<span class="price__badge">' + escapeHtml(String(discountPercentage)) + '%</span>' : '',
        '</div>',
        summary ? '<p class="quick-view__summary">' + escapeHtml(summary) + '</p>' : '',
        '<form class="quick-view__form" data-quick-view-form>',
        product.variants.length > 1
          ? '<div class="variant-picker"><div class="variant-picker__field"><label for="QuickViewVariant">Variant</label><select id="QuickViewVariant" name="id" data-quick-view-variant>' + variantOptions + '</select></div></div>'
          : '<input type="hidden" name="id" value="' + escapeHtml(currentVariant.id) + '" data-quick-view-variant-input>',
        '<div class="quick-view__actions-row">',
        '<div class="quick-view__qty" data-quick-view-qty>',
        '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">-</button>',
        '<input type="number" name="quantity" value="1" min="1" inputmode="numeric" aria-label="Quantity">',
        '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>',
        '</div>',
        '<button class="button button-secondary quick-view__cart-button" type="submit" data-action="cart">Add to cart</button>',
        '</div>',
        '<button class="button quick-view__buy-button" type="submit" data-action="checkout">Buy it now</button>',
        '<div class="quick-view__note-list">',
        '<span>Modern quick view</span>',
        '<span>Direct cart flow</span>',
        '<span>Secure checkout</span>',
        '</div>',
        '<p class="form-status" data-quick-view-status hidden></p>',
        '</form>',
        product.description
          ? '<details class="quick-view__details"><summary>Product details</summary><div class="rte quick-view__description">' + product.description + '</div></details>'
          : '',
        '<a class="quick-view__link" href="' + escapeHtml(fallbackUrl) + '">Open full product page</a>',
        '</div>',
        '</div>'
      ].join('');

      hydrateQuickView(content.querySelector('[data-quick-view-root]'), product);

      var closeButton = modal.querySelector('.quick-view__close');
      releaseQuickViewFocusTrap();
      releaseQuickViewFocusTrap = enableFocusTrap(dialog, closeButton || dialog);
    }

    function hydrateQuickView(container, product) {
      if (!container) return;

      var form = container.querySelector('[data-quick-view-form]');
      var select = container.querySelector('[data-quick-view-variant]');
      var hiddenVariantInput = container.querySelector('[data-quick-view-variant-input]');
      var quantityInput = container.querySelector('[name="quantity"]');
      var price = container.querySelector('[data-quick-view-price]');
      var image = container.querySelector('.quick-view__image');
      var status = container.querySelector('[data-quick-view-status]');
      var stock = container.querySelector('.quick-view__stock');
      var submitButtons = Array.prototype.slice.call(container.querySelectorAll('[type="submit"]'));
      var quantityButtons = Array.prototype.slice.call(container.querySelectorAll('[data-qty-change]'));

      function getCurrentVariant() {
        if (select) {
          var selectedId = Number(select.value);
          return product.variants.find(function (variant) {
            return variant.id === selectedId;
          });
        }

        return product.variants[0];
      }

      function updateVariantState() {
        var currentVariant = getCurrentVariant();
        if (!currentVariant) return;

        if (hiddenVariantInput) {
          hiddenVariantInput.value = currentVariant.id;
        }

        if (price) {
          var hasComparePrice = currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price;
          syncPriceDisplay(
            price,
            formatMoney(currentVariant.price),
            hasComparePrice ? formatMoney(currentVariant.compare_at_price) : '',
            hasComparePrice ? getDiscountPercentage(currentVariant.price, currentVariant.compare_at_price) : 0
          );
        }

        if (image) {
          var nextImage = getVariantImage(product, currentVariant);
          if (nextImage) {
            image.src = nextImage;
            image.alt = product.title;
          }
        }

        if (stock) {
          stock.textContent = currentVariant.available ? 'In stock' : 'Sold out';
          stock.classList.toggle('is-in', currentVariant.available);
          stock.classList.toggle('is-out', !currentVariant.available);
        }

        submitButtons.forEach(function (button) {
          button.disabled = !currentVariant.available;
        });
      }

      if (select) {
        select.addEventListener('change', updateVariantState);
      }

      quantityButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var nextValue = Math.max(1, (Number(quantityInput.value) || 1) + Number(button.dataset.qtyChange || 0));
          quantityInput.value = nextValue;
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var submitter = event.submitter || form.querySelector('[data-action="cart"]');
        var currentVariant = getCurrentVariant();
        var quantity = Math.max(1, Number(quantityInput.value) || 1);
        var originalLabels = submitButtons.map(function (button) {
          return button.textContent;
        });

        if (!currentVariant || !currentVariant.available) return;

        submitButtons.forEach(function (button) {
          button.disabled = true;
          button.textContent = button.dataset.action === 'checkout' ? 'Processing...' : 'Adding...';
        });

        if (status) {
          status.hidden = true;
          status.textContent = '';
          status.classList.remove('is-error');
        }

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: currentVariant.id,
                quantity: quantity
              }
            ]
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error(data.description || 'Unable to add this product to the cart.');
              });
            }

            if (submitter && submitter.dataset.action === 'checkout') {
              window.location.href = rootUrl + 'checkout';
              return;
            }

            if (window.SarabCartDrawer && typeof window.SarabCartDrawer.refresh === 'function') {
              if (window.SarabQuickView && typeof window.SarabQuickView.close === 'function') {
                window.SarabQuickView.close();
              }
              return window.SarabCartDrawer.refresh(true);
            }

            window.location.href = rootUrl + 'cart';
          })
          .catch(function (error) {
            submitButtons.forEach(function (button, index) {
              button.disabled = false;
              button.textContent = originalLabels[index];
            });

            if (status) {
              status.hidden = false;
              status.textContent = error.message;
              status.classList.add('is-error');
            } else {
              window.alert(error.message);
            }
          });
      });

      updateVariantState();
    }
  }

  function initCartPage(root) {
    root.querySelectorAll('[data-cart-page]').forEach(function (form) {
      if (form.dataset.initialized === 'true') return;

      form.dataset.initialized = 'true';

      form.querySelectorAll('[data-cart-line-qty]').forEach(function (wrapper) {
        var input = wrapper.querySelector('[data-cart-page-qty-input]');
        if (!input) return;

        wrapper.querySelectorAll('[data-cart-page-qty-change]').forEach(function (button) {
          button.addEventListener('click', function () {
            var nextValue = Math.max(0, (Number(input.value) || 0) + Number(button.dataset.cartPageQtyChange || 0));
            input.value = nextValue;
          });
        });

        input.addEventListener('change', function () {
          input.value = Math.max(0, Number(input.value) || 0);
        });
      });
    });
  }

  function initContactSuccessPopup(root) {
    root.querySelectorAll('[data-contact-success-popup]').forEach(function (popup) {
      if (popup.dataset.bound === 'true') return;

      popup.dataset.bound = 'true';

      var dialog = popup.querySelector('.contact-success-popup__dialog');
      var closeButton = dialog ? dialog.querySelector('[data-contact-success-close]') : null;
      var closeControls = Array.prototype.slice.call(popup.querySelectorAll('[data-contact-success-close]'));
      var previousActiveElement = document.activeElement;
      var releasePopupFocusTrap = function () {};

      document.body.classList.add('contact-success-popup-open');

      releasePopupFocusTrap = enableFocusTrap(dialog, closeButton || dialog);

      function closePopup() {
        releasePopupFocusTrap();
        popup.classList.add('is-hidden');
        document.body.classList.remove('contact-success-popup-open');

        if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
          previousActiveElement.focus();
        }
      }

      closeControls.forEach(function (control) {
        control.addEventListener('click', closePopup);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !popup.classList.contains('is-hidden')) {
          closePopup();
        }
      });
    });
  }

  function initProductReviewModal(root) {
    root.querySelectorAll('[data-product-review-section]').forEach(function (section) {
      if (section.dataset.reviewModalBound === 'true') return;

      section.dataset.reviewModalBound = 'true';

      var modal = section.querySelector('[data-product-review-modal]');
      if (!modal) return;

      var dialog = modal.querySelector('.product-review-modal__dialog');
      var firstField = modal.querySelector('[data-review-modal-field]');
      var closeControls = Array.prototype.slice.call(modal.querySelectorAll('[data-product-review-close]'));
      var triggers = Array.prototype.slice.call(section.querySelectorAll('[data-review-modal-trigger]'));
      var widget = section.querySelector('[data-product-review-widget]');
      var previousActiveElement = null;
      var releaseReviewFocusTrap = function () {};
      var reviewActionSelectors = [
        '.jdgm-write-rev-link',
        '.jdgm-rev-widg__write-btn',
        '.spr-summary-actions-newreview',
        '.spr-form-input-textarea',
        '.stamped-summary-actions-newreview',
        '.stamped-write-review-button',
        '.ryviu-writereview',
        '.ryviu-write-review',
        '.wc_product_review_write_review',
        '.opw-open-review-form',
        '.yotpo-default-button.write-review-button',
        '.loox-btn-write-review',
        '#looxReviews'
      ];

      function openWidgetReviewFlow() {
        var reviewAction = null;

        reviewActionSelectors.some(function (selector) {
          reviewAction = section.querySelector(selector) || document.querySelector(selector);
          return Boolean(reviewAction);
        });

        if (!reviewAction && widget) {
          reviewAction = widget;
        }

        if (!reviewAction) return false;

        reviewAction.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        window.requestAnimationFrame(function () {
          if (typeof reviewAction.click === 'function' && reviewAction !== widget) {
            reviewAction.click();
          }

          var focusTarget = getFocusableElements(reviewAction)[0] || getFocusableElements(widget || reviewAction)[0];
          if (focusTarget && typeof focusTarget.focus === 'function') {
            focusTarget.focus();
          }
        });

        return true;
      }

      function openModal() {
        releaseReviewFocusTrap();

        if (document.activeElement && typeof document.activeElement.focus === 'function') {
          previousActiveElement = document.activeElement;
        }

        modal.hidden = false;
        document.body.classList.add('product-review-modal-open');
        releaseReviewFocusTrap = enableFocusTrap(dialog, firstField || dialog);
      }

      function closeModal() {
        releaseReviewFocusTrap();
        releaseReviewFocusTrap = function () {};
        modal.hidden = true;
        document.body.classList.remove('product-review-modal-open');

        if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
          previousActiveElement.focus();
        }
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();

          if (openWidgetReviewFlow()) return;

          previousActiveElement = trigger;
          openModal();
        });
      });

      closeControls.forEach(function (control) {
        control.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });

      if (modal.querySelector('[data-review-modal-open="true"]')) {
        openModal();
      }
    });
  }

  function initProductReviewLinks(root) {
    root.querySelectorAll('[data-product-review-link]').forEach(function (link) {
      if (link.dataset.reviewLinkBound === 'true') return;

      link.dataset.reviewLinkBound = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        waitForProductReviewTarget(true);
      });
    });
  }

  function getProductReviewTarget() {
    var selectors = [
      '#product-reviews',
      '[id*="lai_product_reviews"]',
      '[class*="lai-product-reviews"]',
      '[data-lai-product-reviews]',
      '[data-product-review-section]',
      '.jdgm-widget',
      '#looxReviews'
    ];
    var target = null;

    selectors.some(function (selector) {
      target = document.querySelector(selector);
      return Boolean(target);
    });

    return target;
  }

  function getWriteReviewAction(target) {
    if (!target) return null;
    return Array.prototype.slice.call(target.querySelectorAll('button, a, [role="button"]')).find(function (element) {
      return /write\s+(?:a\s+)?review/i.test(element.textContent || element.getAttribute('aria-label') || '');
    }) || null;
  }

  function scrollToReviewTarget(target, shouldFocus) {
    var header = document.querySelector('.site-header');
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var offset = Math.ceil(headerHeight + 16);
    var top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });

    if (shouldFocus) {
      window.setTimeout(function () {
        var action = getWriteReviewAction(target);
        if (action) action.focus({ preventScroll: true });
      }, reduceMotion ? 0 : 450);
    }
  }

  function navigateToProductReviews(shouldFocus) {
    var target = getProductReviewTarget();
    if (target) {
      scrollToReviewTarget(target, shouldFocus);
      return true;
    }
    return false;
  }

  function waitForProductReviewTarget(shouldFocus) {
    if (navigateToProductReviews(shouldFocus)) return;
    window.clearInterval(window.__sarabReviewTargetTimer);
    var attempts = 0;
    window.__sarabReviewTargetTimer = window.setInterval(function () {
      attempts += 1;
      if (navigateToProductReviews(shouldFocus) || attempts >= 20) {
        window.clearInterval(window.__sarabReviewTargetTimer);
      }
    }, 150);
  }

  function initProductReviewHashNavigation() {
    if (window.__sarabReviewHashNavigationBound) return;
    window.__sarabReviewHashNavigationBound = true;

    function handleHash() {
      if (window.location.hash !== '#product-reviews') return;
      waitForProductReviewTarget(false);
    }

    window.addEventListener('hashchange', handleHash);
    handleHash();
  }

  function parseReviewSource(value) {
    var parsed = value;
    var attempts = 0;
    while (typeof parsed === 'string' && attempts < 2) {
      try {
        parsed = JSON.parse(parsed);
      } catch (error) {
        return null;
      }
      attempts += 1;
    }
    return parsed && typeof parsed === 'object' ? parsed : null;
  }

  function findReviewNumber(value, names) {
    if (!value || typeof value !== 'object') return 0;
    var keys = Object.keys(value);
    var directKey = keys.find(function (key) {
      return names.indexOf(key.toLowerCase()) !== -1;
    });
    if (directKey) {
      var directValue = Number(value[directKey]);
      if (Number.isFinite(directValue)) return directValue;
    }
    for (var index = 0; index < keys.length; index += 1) {
      var nestedValue = value[keys[index]];
      if (nestedValue && typeof nestedValue === 'object') {
        var nestedNumber = findReviewNumber(nestedValue, names);
        if (nestedNumber) return nestedNumber;
      }
    }
    return 0;
  }

  function getVisibleReviewMarkup(target) {
    if (!target) return [];
    return Array.prototype.slice.call(target.querySelectorAll(
      '[data-review-id], .scm-review-item, .lai-review-item, [class*="review-item"]'
    )).map(function (card) {
      var author = card.querySelector('[data-review-author], [class*="review-author"], [class*="reviewer-name"], [class*="review-name"]');
      var body = card.querySelector('[data-review-body], [class*="review-content"], [class*="review-body"], [class*="review-text"], [class*="review-description"]');
      var ratingNode = card.querySelector('[data-rating], [data-review-rating], [aria-label*="out of 5"], [aria-label*="stars"]');
      var dateNode = card.querySelector('time[datetime]');
      var ratingText = ratingNode ? (ratingNode.getAttribute('data-rating') || ratingNode.getAttribute('data-review-rating') || ratingNode.getAttribute('aria-label') || ratingNode.textContent || '') : '';
      var ratingMatch = ratingText.match(/([1-5](?:\.\d+)?)\s*(?:out\s+of|\/)\s*5/i);
      var rating = ratingMatch ? Number(ratingMatch[1]) : 0;
      if (!rating) {
        var starText = (ratingNode || card).textContent || '';
        rating = Math.min(5, (starText.match(/★/g) || []).length);
      }
      var review = {
        '@type': 'Review',
        author: { '@type': 'Person', name: author ? author.textContent.trim() : '' },
        reviewRating: { '@type': 'Rating', ratingValue: rating, bestRating: 5 },
        reviewBody: body ? body.textContent.trim() : ''
      };

      if (!review.author.name || !review.reviewBody || !rating) return null;
      if (dateNode && /^\d{4}-\d{2}-\d{2}/.test(dateNode.getAttribute('datetime') || '')) {
        review.datePublished = dateNode.getAttribute('datetime');
      }
      return review;
    }).filter(Boolean);
  }

  function syncProductReviewSchema() {
    var schemaScript = document.querySelector('[data-product-structured-data]');
    if (!schemaScript) return;
    var schema;
    try {
      schema = JSON.parse(schemaScript.textContent);
    } catch (error) {
      return;
    }

    var source = document.querySelector('[data-lai-review-source]');
    var sourceData = source ? parseReviewSource(source.getAttribute('data-lai-review-data') || '') : null;
    var sourceAggregate = sourceData && (sourceData.reviewCountInfo || sourceData.review_count_info) || sourceData;
    var rating = findReviewNumber(sourceAggregate, ['averagerating', 'average_rating', 'ratingvalue', 'rating']);
    var count = findReviewNumber(sourceAggregate, ['reviewcount', 'review_count', 'numberofreviews', 'totalreviews', 'total_review']);
    if (!schema.aggregateRating && rating > 0 && rating <= 5 && Number.isInteger(count) && count > 0) {
      schema.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: rating,
        reviewCount: count,
        bestRating: 5,
        worstRating: 1
      };
    }

    // Review cards can be loaded or re-rendered by an app after this script runs.
    // Do not infer individual Review entities from that changing HTML: the app's
    // product-level aggregate is the only data source used here.
    delete schema.review;
    schemaScript.textContent = JSON.stringify(schema);
  }

  function initProductReviewSchema() {
    if (window.__sarabReviewSchemaBound) return;
    window.__sarabReviewSchemaBound = true;
    window.setTimeout(syncProductReviewSchema, 500);
    window.setTimeout(syncProductReviewSchema, 1800);
  }

  function initCritical(root) {
    var isDocumentRoot = root === document;
    var isHomeTemplate = isDocumentRoot && document.body && document.body.classList.contains('template-index');

    initHeader(root);
    initCartDrawer(root);

    if (isHomeTemplate) {
      return;
    }

    initSliders(root);
    initVariantForms(root);
    initCartFlowForms(root);
    initCartPage(root);
    initContactSuccessPopup(root);
  }

  function initDeferred(root) {
    initSliders(root);
    initVariantForms(root);
    initCartFlowForms(root);
    initCartPage(root);
    initContactSuccessPopup(root);
    initTabbedCollections(root);
    initProductSupportTabs(root);
    initCollectionSliders(root);
    initBestSellerSliders(root);
    initConcernSliders(root);
    initLogoRails(root);
    initQuickView(root);
    initProductReviewModal(root);
    initProductReviewLinks(root);
    initProductReviewHashNavigation();
    initProductReviewSchema();
    initWishlist(root);
    initCollectionLoadMore(root);
  }

  function initCollectionLoadMore(root) {
    root.querySelectorAll('[data-collection-load-more]').forEach(function (container) {
      if (container.dataset.initialized === 'true') return;

      var button = container.querySelector('[data-collection-load-more-button]');
      var status = container.querySelector('[data-collection-load-more-status]');
      var grid = document.querySelector('[data-collection-product-grid]');
      if (!button || !grid) return;

      container.dataset.initialized = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (button.dataset.loading === 'true') return;

        var nextUrl = button.href;
        if (!nextUrl) return;

        button.dataset.loading = 'true';
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Loading products…';
        if (status) status.textContent = 'Loading more products.';

        fetch(nextUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to load products.');
            return response.text();
          })
          .then(function (html) {
            var page = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = page.querySelector('[data-collection-product-grid]');
            var nextControl = page.querySelector('[data-collection-load-more]');
            if (!nextGrid) throw new Error('Product grid not found.');

            var newCards = Array.prototype.slice.call(nextGrid.children);
            newCards.forEach(function (card) {
              grid.appendChild(document.importNode(card, true));
            });

            initDeferred(grid);

            if (nextControl) {
              var nextButton = nextControl.querySelector('[data-collection-load-more-button]');
              if (nextButton && nextButton.href) {
                button.href = nextButton.href;
                button.textContent = 'Load More';
                button.removeAttribute('aria-busy');
                button.dataset.loading = 'false';
                if (status) status.textContent = newCards.length + ' more products loaded.';
                return;
              }
            }

            if (status) status.textContent = 'All products are loaded.';
            container.remove();
          })
          .catch(function () {
            button.textContent = 'Try loading again';
            button.removeAttribute('aria-busy');
            button.dataset.loading = 'false';
            if (status) status.textContent = 'Unable to load more products. Please try again.';
          });
      });
    });
  }

  function scheduleHomepageWidgets(root) {
    var isHomeDocument = root === document && document.body && document.body.classList.contains('template-index');
    if (!isHomeDocument || typeof window.IntersectionObserver !== 'function') return false;

    // Keep the visible hero interactive, then initialize lower homepage widgets
    // shortly before they enter the viewport. This avoids binding every slider
    // and product-card enhancement during the initial render.
    initSliders(root);

    var observedSections = [];
    var selector = [
      '[data-tabbed-collections]',
      '[data-collection-slider]',
      '[data-best-seller-slider]',
      '[data-concern-slider]',
      '[data-logo-rail]',
      '[data-cart-flow-form]',
      '[data-quick-view-trigger]',
      '[data-wishlist-trigger]'
    ].join(', ');

    root.querySelectorAll(selector).forEach(function (widget) {
      var section = widget.closest('.shopify-section') || widget;
      if (section.__sarabVisibleInitObserved || observedSections.indexOf(section) !== -1) return;

      section.__sarabVisibleInitObserved = true;
      observedSections.push(section);
    });

    if (!observedSections.length) return true;

    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        observer.unobserve(entry.target);
        initDeferred(entry.target);
      });
    }, { rootMargin: '280px 0px' });

    observedSections.forEach(function (section) {
      observer.observe(section);
    });

    return true;
  }

  function scheduleDeferredInit(root) {
    if (!root || root.__sarabDeferredInitScheduled) return;

    root.__sarabDeferredInitScheduled = true;

    function runDeferredInit() {
      if (root.__sarabDeferredInitDone) return;
      root.__sarabDeferredInitDone = true;

      if (scheduleHomepageWidgets(root)) return;
      initDeferred(root);
    }

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(runDeferredInit, { timeout: 1200 });
      return;
    }

    // Safari does not support requestIdleCallback. Keep non-essential widgets
    // (rails, review helpers, wishlist and collection enhancements) off the
    // initial rendering path while critical commerce controls initialize above.
    window.setTimeout(runDeferredInit, 250);
  }

  function init(root) {
    initCritical(root);
    initDeferred(root);
  }

  function initWishlist(root) {
    var storageKey = 'sarabherbs_wishlist';
    var wishlist = JSON.parse(localStorage.getItem(storageKey) || '[]');

    function isInWishlist(productId) {
      return wishlist.some(function (item) {
        return item === productId;
      });
    }

    function updateWishlistUI() {
      root.querySelectorAll('[data-wishlist-trigger]').forEach(function (button) {
        var productId = button.dataset.productId;
        var isActive = isInWishlist(productId);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }

    root.querySelectorAll('[data-wishlist-trigger]').forEach(function (button) {
      if (button.dataset.wishlistBound === 'true') return;

      button.dataset.wishlistBound = 'true';
      var productId = button.dataset.productId;

      if (isInWishlist(productId)) {
        button.classList.add('is-active');
      }

      button.addEventListener('click', function () {
        if (isInWishlist(productId)) {
          wishlist = wishlist.filter(function (id) {
            return id !== productId;
          });
          button.classList.remove('is-active');
        } else {
          wishlist.push(productId);
          button.classList.add('is-active');
        }

        localStorage.setItem(storageKey, JSON.stringify(wishlist));
        updateWishlistUI();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCritical(document);
    scheduleDeferredInit(document);
  });

  window.addEventListener('load', function () {
    scheduleDeferredInit(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

/* Home welcome offer popup */
(function () {
  function initWelcomeOffer(root) {
    var popup = (root || document).querySelector('[data-welcome-offer-popup]');
    if (!popup || popup.dataset.welcomeOfferBound === 'true') return;
    popup.dataset.welcomeOfferBound = 'true';
    var dialog = popup.querySelector('.welcome-offer-popup__dialog');
    var storageKey = popup.dataset.storageKey;
    var delay = Math.max(3000, Math.min(5000, Number(popup.dataset.delay) || 4000));
    var previousFocus = null;
    var releaseFocusTrap = function () {};
    function trapFocus(container, initialFocus) {
      function handleKeydown(event) {
        if (event.key !== 'Tab') return;
        var focusable = Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) { event.preventDefault(); container.focus(); return; }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
      document.addEventListener('keydown', handleKeydown);
      window.requestAnimationFrame(function () { (initialFocus || container).focus(); });
      return function () { document.removeEventListener('keydown', handleKeydown); };
    }
    try { if (storageKey && window.sessionStorage.getItem(storageKey)) return; } catch (error) {}
    function closePopup() {
      popup.hidden = true; popup.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('welcome-offer-open'); releaseFocusTrap();
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      try { if (storageKey) window.sessionStorage.setItem(storageKey, 'closed'); } catch (error) {}
    }
    function openPopup() {
      if (!document.body.contains(popup)) return;
      previousFocus = document.activeElement; popup.hidden = false; popup.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('welcome-offer-open');
      releaseFocusTrap = trapFocus(dialog, popup.querySelector('[data-welcome-offer-copy]'));
    }
    popup.querySelectorAll('[data-welcome-offer-close]').forEach(function (button) { button.addEventListener('click', closePopup); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !popup.hidden) closePopup(); });
    var copyButton = popup.querySelector('[data-welcome-offer-copy]'); var code = popup.querySelector('[data-welcome-offer-code]');
    if (copyButton && code) copyButton.addEventListener('click', function () {
      var originalLabel = copyButton.textContent; var copied = function () { copyButton.textContent = 'Copied'; window.setTimeout(function () { copyButton.textContent = originalLabel; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code.textContent.trim()).then(copied).catch(function () {});
    });
    window.setTimeout(openPopup, delay);
  }
  document.addEventListener('DOMContentLoaded', function () { initWelcomeOffer(document); });
  document.addEventListener('shopify:section:load', function (event) { initWelcomeOffer(event.target); });
})();

/* PDP upsells -------------------------------------------------------------
   These initialisers only work inside their own data-* section roots. This
   prevents generic card/slider controls from affecting other PDP sections. */
(function () {
  function getRootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function openCheckoutForCart(checkoutUrl) {
    // This is deliberately a normal checkout link, not the product-only Buy
    // Now hook. It preserves every FBT item already present in the cart, while
    // still allowing a checkout app embed to intercept the customer click.
    var checkoutLink = document.createElement('a');
    checkoutLink.href = checkoutUrl;
    checkoutLink.hidden = true;
    document.body.appendChild(checkoutLink);
    checkoutLink.click();
    window.setTimeout(function () {
      checkoutLink.remove();
    }, 0);
  }

  function initFrequentlyBought(root) {
    var sections = root.querySelectorAll ? root.querySelectorAll('[data-fbt-section]') : [];

    sections.forEach(function (section) {
      if (section.dataset.fbtInitialized === 'true') return;
      section.dataset.fbtInitialized = 'true';

      var discountPercent = Number(section.dataset.discountPercent || 0);
      var checkboxes = section.querySelectorAll('.fbt-checkbox');
      var originalPriceEl = section.querySelector('[data-fbt-original-price]');
      var discountedPriceEl = section.querySelector('[data-fbt-discounted-price]');
      var saveBadgeEl = section.querySelector('[data-fbt-save-badge]');
      var addToCartBtn = section.querySelector('[data-fbt-add-to-cart]');

      function updateTotal() {
        var totalPrice = 0;
        checkboxes.forEach(function (checkbox) {
          if (checkbox.checked) totalPrice += Number(checkbox.dataset.price || 0);
        });

        var discountAmount = (totalPrice * discountPercent) / 100;
        var finalPrice = totalPrice - discountAmount;
        if (originalPriceEl) originalPriceEl.textContent = '₹' + (totalPrice / 100).toFixed(2);
        if (discountedPriceEl) discountedPriceEl.textContent = '₹' + (finalPrice / 100).toFixed(2);

        if (saveBadgeEl) {
          var showBadge = discountPercent > 0 && totalPrice > 0;
          saveBadgeEl.hidden = !showBadge;
          if (showBadge) saveBadgeEl.textContent = 'Save ₹' + (discountAmount / 100).toFixed(2) + ' (' + discountPercent + '% OFF)';
        }
      }

      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', updateTotal);
      });

      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () {
          var items = [];
          checkboxes.forEach(function (checkbox) {
            if (checkbox.checked && checkbox.dataset.variantId) {
              items.push({ id: Number(checkbox.dataset.variantId), quantity: 1, properties: { _bundle: 'Frequently Bought Together' } });
            }
          });
          if (!items.length) return;

          addToCartBtn.disabled = true;
          addToCartBtn.textContent = addToCartBtn.dataset.loadingLabel || 'ADDING...';
          fetch(getRootUrl() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (response) {
            if (!response.ok) throw new Error('Unable to add bundle');
            return response.json();
          }).then(function () {
            return fetch(getRootUrl() + 'cart.js', {
              headers: { Accept: 'application/json' }
            });
          }).then(function (response) {
            if (!response.ok) throw new Error('Unable to verify bundle cart');
            return response.json();
          }).then(function (cart) {
            var hasEverySelectedItem = items.every(function (selectedItem) {
              return cart.items.some(function (cartItem) {
                return Number(cartItem.variant_id) === selectedItem.id && cartItem.quantity >= selectedItem.quantity;
              });
            });
            if (!hasEverySelectedItem) throw new Error('Not every selected bundle item was added');

            addToCartBtn.textContent = addToCartBtn.dataset.successLabel || 'ADDED!';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:build'));
            openCheckoutForCart(section.dataset.checkoutUrl || getRootUrl() + 'checkout');
          }).catch(function (error) {
            console.error('Frequently Bought Together cart error:', error);
            addToCartBtn.textContent = addToCartBtn.dataset.originalLabel || 'ADD SELECTED TO CART';
            addToCartBtn.disabled = false;
          });
        });
      }

      updateTotal();
    });
  }

  function initUpsellPairs(root) {
    var sections = root.querySelectorAll ? root.querySelectorAll('[data-upsell-section]') : [];

    sections.forEach(function (section) {
      if (section.dataset.upsellInitialized === 'true') return;
      section.dataset.upsellInitialized = 'true';

      var slider = section.querySelector('.js-upsell-grid');
      var previous = section.querySelector('.js-slider-prev');
      var next = section.querySelector('.js-slider-next');
      var timer;

      function stopTimer() { if (timer) { window.clearInterval(timer); timer = null; } }
      function getSlideWidth() {
        if (!slider) return 0;
        var card = slider.querySelector('.upsell-card');
        if (!card) return slider.clientWidth;
        var styles = window.getComputedStyle(slider);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function slideNext() {
        if (!slider) return;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        if (slider.scrollLeft >= maxScroll - 10) slider.scrollTo({ left: 0, behavior: 'smooth' });
        else slider.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
      }
      function slidePrevious() {
        if (!slider) return;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        if (slider.scrollLeft <= 0) slider.scrollTo({ left: maxScroll, behavior: 'smooth' });
        else slider.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
      }
      function startTimer() { stopTimer(); if (slider) timer = window.setInterval(slideNext, 3000); }

      if (slider) {
        slider.addEventListener('mouseenter', stopTimer);
        slider.addEventListener('mouseleave', startTimer);
        slider.addEventListener('focusin', stopTimer);
        slider.addEventListener('focusout', startTimer);
        slider.addEventListener('touchstart', stopTimer, { passive: true });
        startTimer();
      }
      if (previous) previous.addEventListener('click', function () { slidePrevious(); startTimer(); });
      if (next) next.addEventListener('click', function () { slideNext(); startTimer(); });

      section.querySelectorAll('.upsell-card').forEach(function (card) {
        var minus = card.querySelector('[data-action="minus"]');
        var plus = card.querySelector('[data-action="plus"]');
        var quantity = card.querySelector('.js-qty-input');
        var variantSelect = card.querySelector('.js-variant-select');
        var hiddenVariant = card.querySelector('.js-variant-id');
        var addButton = card.querySelector('.js-add-to-cart');

        if (minus && quantity) minus.addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
        if (plus && quantity) plus.addEventListener('click', function () { quantity.value = Number(quantity.value || 1) + 1; });
        if (variantSelect && addButton) variantSelect.addEventListener('change', function () {
          var option = variantSelect.options[variantSelect.selectedIndex];
          addButton.dataset.variantId = variantSelect.value;
          addButton.disabled = option.disabled;
          addButton.textContent = option.disabled ? 'Sold Out' : 'Add to cart';
          var price = card.querySelector('.current-price');
          var compare = card.querySelector('.old-price');
          if (price) price.textContent = option.dataset.price || '';
          if (compare) compare.textContent = option.dataset.compare || '';
        });
        if (addButton) addButton.addEventListener('click', function () {
          var variantId = addButton.dataset.variantId || (hiddenVariant && hiddenVariant.value);
          if (!variantId) return;
          addButton.disabled = true;
          addButton.textContent = 'Adding...';
          fetch(getRootUrl() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number((quantity && quantity.value) || 1) }] })
          }).then(function (response) {
            if (!response.ok) throw new Error('Unable to add product');
            return response.json();
          }).then(function () {
            addButton.textContent = 'Added!';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:build'));
            window.setTimeout(function () { addButton.disabled = false; addButton.textContent = 'Add to cart'; }, 2000);
          }).catch(function (error) {
            console.error('Upsell cart error:', error);
            addButton.disabled = false;
            addButton.textContent = 'Add to cart';
          });
        });
      });
    });
  }

  function initPdpUpsells(root) {
    initFrequentlyBought(root);
    initUpsellPairs(root);
  }

  function closeMobileProductOffers(root) {
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    root.querySelectorAll('.product-offers[open]').forEach(function (offers) {
      offers.removeAttribute('open');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPdpUpsells(document);
    closeMobileProductOffers(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    initPdpUpsells(event.target);
    closeMobileProductOffers(event.target);
  });
})();

/* --- Header Scroll Detection --- */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var spacer = document.querySelector('.site-header-spacer');
  var scrollThreshold = 40;
  var ticking = false;

  function syncHeaderHeight() {
    document.documentElement.style.setProperty('--site-header-height', header.offsetHeight + 'px');
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (window.scrollY > scrollThreshold) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', syncHeaderHeight, { passive: true });
  if ('ResizeObserver' in window) {
    new ResizeObserver(syncHeaderHeight).observe(header);
  }
  if (spacer) syncHeaderHeight();
  onScroll();
})();

/* --- Scroll Reveal (IntersectionObserver) --- */
(function () {
  var targets = document.querySelectorAll(
    '.section-shell, .best-seller-grid-section, .tabbed-collections-shell, .testimonial-shell, .concern-section, .newsletter-banner'
  );
  if (!targets.length || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );

  targets.forEach(function (el) {
    el.style.animationPlayState = 'paused';
    observer.observe(el);
  });
})();
